import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withTitle } from '../../Application';
import ProfileView from '../../ui/views/User/User';
import {changePassword, deleteUser} from '../../connectors/Users/actions';
import {fetchDevices} from "../../connectors/Devices/actions";
import {apiAddress, apiClient} from "../../services/api";
import {whiteLabelData} from "../../ui/theme"
import log from 'loglevel'
import { t } from 'i18next';

var pageTitle = ""
const title = whiteLabelData.name



const mapStateToProps = state => ({
  title: state.application.title,
  user: state.authentication.user,
  accessToken: state.authentication.accessToken,
  currentDeviceId: (state.devices.map[state.devices.active] || { settings: {} }).deviceid,
});

const mapDispatchToProps = dispatch => ({
  deleteUser: (successCb, errorCb) => dispatch(deleteUser(successCb, errorCb)),
  changePassword: (currentPw, newPw, successCb, errorCb) => dispatch(changePassword(currentPw, newPw, successCb, errorCb)),
  fetchDevices: () => dispatch(fetchDevices()),
});

/**
 * Profile
 */
class Profile extends PureComponent {
  state = {
    tokenData: "",
    tokenIssued: false
  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    user: PropTypes.shape({
      _id: PropTypes.string.isRequired,
    }).isRequired,
    accessToken: PropTypes.string.isRequired,
    deleteUser: PropTypes.func.isRequired,
  }

  static defaultProps = {

  }


  revokeToken = () => {
    apiClient.delete('/access_token').then(
      (res, err) => {
        if(!err){
          this.setState({tokenData: "", tokenIssued: false})
        }
        log.debug(res)
      }
    )
  }

  requestToken = () => {


    apiClient.post('/access_token', 'grant_type=password').then(
      (res, err) => {
        if(!err){
          this.setState({tokenData: res.data.access_token, tokenIssued: true})
        }
      }
    ).catch(err => {
      log.error("Catch error:", err)
    })
  }

  componentWillMount(){
  pageTitle = t('PageTitles.user')
  this.secondLoad()
  }

  resetToken = () =>{
    apiClient.get('/access_token').then(
      (res, err) => {
        if(!err){
          var date = `Token erstellt am ${res.data[8]}${res.data[9]}.${res.data[5]}${res.data[6]}.${res.data[0]}${res.data[1]}${res.data[2]}${res.data[3]}`
          this.setState({tokenData: date, tokenIssued: false})
        }
        log.debug(res)
      }
    )
  }

  secondLoad = () => {
    var data = { deviceid: this.props.currentDeviceId }
    log.debug("SECONDLOAD")
    // log.debug(log.debug(ip))
    log.debug(apiClient)
    apiClient.post('control/settings/store', data)
      .then(res => {
        if (res.status === 200) {
          log.debug("STATE UPDATE CMD OK")
          this.props.fetchDevices()
        }
      })
      .then(()=> {
        setTimeout(() =>{
          this.props.fetchDevices()
            log.debug("2 Seconds LATER")

      }, 2000)
      })
      apiClient.get('/access_token').then(
      (res, err) => {
        if(!err){
          var date = `Token erstellt am ${res.data[8]}${res.data[9]}.${res.data[5]}${res.data[6]}.${res.data[0]}${res.data[1]}${res.data[2]}${res.data[3]}`
          this.setState({tokenData: date, tokenIssued: false})
        }
        log.debug(res)
      }
    )
  }

  render() {
    return (
      <ProfileView
        title={pageTitle}
        user={this.props.user}
        router={this.props.history}
        onAccountDeletion={this.props.deleteUser}
        onAccountChangePassword={this.props.changePassword}
        tokenData= {this.state.tokenData}
        tokenIssued= {this.state.tokenIssued}
        revokeToken= {this.revokeToken}
        requestToken= {this.requestToken}
        resetToken={this.resetToken}
      />
    );
  }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile)), title);
